import { GET_SUB_CATEGORIES, ADD_NEW_SUB_CATEGORY, EDIT_SUB_CATEGORY, DELETE_SUB_CATEGORY } from './sub-category-management.constant'

export const getSubCategories = (payload, callback) => ({ type: GET_SUB_CATEGORIES, payload, callback })

export const addNewSubCategory = (payload, callback) => ({ type: ADD_NEW_SUB_CATEGORY, payload, callback })

export const editSubCategoryDetails = (payload, callback) => ({ type: EDIT_SUB_CATEGORY, payload, callback })

export const deleteSubCategory = (payload, callback) => ({ type: DELETE_SUB_CATEGORY, payload, callback })